import type { FC, PropsWithChildren } from 'react'
import { Suspense } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { observer } from 'mobx-react-lite'

import { FileUploadPanel } from '@jotta/files'
import { AppLayout } from '@jotta/ui/AppLayout'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'
import { OnboardingContext } from '@jotta/ui/Onboarding'
import { useBrandStore } from '@jotta/ui/useBrandTheme'
import { WelcomeDialog } from '@jotta/ui/WelcomeDialog'

import { Header } from './Header'
import { NavBar } from './NavBar'
import { WebappBanner } from './WebappBanner'
import { WebappModuleNav } from './WebappModuleNav'

export const PrivateLayout: FC<PropsWithChildren> = observer(
  function WebappLayout({ children = <Outlet /> }) {
    const { pathname } = useLocation()
    const brandStore = useBrandStore()
    const overlay = brandStore.slots.overlay
    const hasOverlay = brandStore.hasOverlay
    // Photos still use UploadPhotoQueueStatus; hide the file panel there to
    // avoid stacking two uploaders until photos migrate to useUploadStore.
    const showFileUploadPanel = !pathname.startsWith('/photo')
    return (
      <OnboardingContext.Provider value={true}>
        <AppLayout
          navbar={<NavBar />}
          banner={<WebappBanner />}
          moduleNav={<WebappModuleNav />}
          header={<Header />}
          overlay={hasOverlay ? overlay : undefined}
        >
          <Suspense fallback={<LoadingOverlay id="PrivateLayout" open />}>
            {children}
          </Suspense>
          <WelcomeDialog />
          {showFileUploadPanel && <FileUploadPanel />}
        </AppLayout>
      </OnboardingContext.Provider>
    )
  },
)
